exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "media{width:100%;min-width:800px}media md-card{width:98%}media .truncated{max-width:150px}media table.md-table:not(.md-row-select) td.md-cell:nth-child(n+2):nth-last-child(n+2),media table.md-table:not(.md-row-select) th.md-column:nth-child(n+2):nth-last-child(n+2){padding:0 16px 0 0}media md-select.md-table-select>.md-select-value>span>.md-text{display:inline-block!important}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader!./sources/components/media/media.scss
// module id = 779
// module chunks = 0